import React from 'react'
import CountUp from 'react-countup'
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
    numbersSection: {
        padding: '80px 0',
        textAlign: 'center',
        backgroundColor: '#e8f1f5',

        '@media only screen and (max-width: 480px)': {
            paddingTop: '60px',
            paddingBottom: '50px',
        },

        '& .col-4': {
            '@media only screen and (max-width: 480px)': {
                paddingLeft: '7px',
                paddingRight: '7px',
            },
            '@media only screen and (max-width: 380px)': {
                paddingLeft: '5px',
                paddingRight: '5px',
            },
        },
    },
    numbersHeader: {
        paddingBottom: '30px',
        color: 'black',
    },
    
    numberBlock: {
        backgroundColor: 'white',
        borderRadius: '10px',
        padding: '40px 40px',
        boxShadow: '0px 0px 15px var(--darkblue-hover)',
        height: '100%',
        '@media only screen and (max-width: 768px)': {
            borderRadius: '10px',
            padding: '25px',
        },
        '@media only screen and (max-width: 480px)': {
            borderRadius: '7px',
            padding: '13px',
        },
        '@media only screen and (max-width: 380px)': {
            borderRadius: '7px',
            padding: '8px',
        },

        '& h3': {
            fontWeight: 'bold',
            '@media only screen and (max-width: 480px)': {
                fontSize: '16px',
            },
            '@media only screen and (max-width: 380px)': {
                fontSize: '14px',
            },
        },
        
        '& h1': {
            fontSize: '60px',
            '@media only screen and (max-width: 768px)': {
                fontSize: '40px',
            },
            '@media only screen and (max-width: 480px)': {
                fontSize: '25px',
            },
            '@media only screen and (max-width: 380px)': {
                fontSize: '20px',
            },
        },
        
        '& p': {
            color: '#555',
            marginBottom: 0,
            '@media only screen and (max-width: 480px)': {
                fontSize: '12px',
            },
            '@media only screen and (max-width: 380px)': {
                fontSize: '11px',
            },
        }
    },
});

function Achievements() {

    var classes = useStyles()

    return (
        <div className={classes.numbersSection}>
            <div className="container">
                <div className={classes.numbersHeader}>
                    <h1>Our Journey so far</h1>
                </div>
                <div className="row" style={{justifyContent: 'center'}}>
                    <div className="col-lg-3 col-4 pb-3">
                        <div className={classes.numberBlock}>
                            <h3>Mentors</h3>
                            <h1><CountUp end={30} duration={3}/>+</h1>
                            <p>Experts and mentors onboard</p>
                        </div>
                    </div>
                    <div className="col-lg-3 col-4 pb-3">
                        <div className={classes.numberBlock}>
                            <h3>Partners</h3>
                            <h1><CountUp end={10} duration={3}/>+</h1>
                            <p>Partners associated with us</p>
                        </div>
                    </div>
                    <div className="col-lg-3 col-4 pb-3">
                        <div className={classes.numberBlock}>
                            <h3>Students Trained</h3>
                            <h1><CountUp end={1000} duration={3}/>+</h1>
                            <p>Learners have been associated with us</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Achievements
